import { render, staticRenderFns } from "./orderServicerAdd.vue?vue&type=template&id=57c47e2c&"
import script from "./orderServicerAdd.vue?vue&type=script&lang=ts&"
export * from "./orderServicerAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports